module.exports = __webpack_public_path__ + "img/kutxabank-dark.1b120684.png";